import React from 'react';
import Icon from '../../../components/AppIcon';

const OverallHealthIndicator = ({ status }) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'healthy':
        return { icon: 'CheckCircle', color: 'text-success', bg: 'bg-success/10', border: 'border-success/20', label: 'All Systems Operational', desc: 'All services are running normally' };
      case 'degraded': case'partial':
        return { icon: 'AlertTriangle', color: 'text-warning', bg: 'bg-warning/10', border: 'border-warning/20', label: 'Partial Outage', desc: 'Some services may be experiencing issues' };
      case 'error':
        return { icon: 'XCircle', color: 'text-destructive', bg: 'bg-destructive/10', border: 'border-destructive/20', label: 'System Issues Detected', desc: 'Multiple services are experiencing problems' };
      default:
        return { icon: 'Activity', color: 'text-muted-foreground', bg: 'bg-muted', border: 'border-border', label: 'Checking Status...', desc: 'Running diagnostics' };
    }
  };

  const config = getStatusConfig();

  return (
    <div className={`${config?.bg} border ${config?.border} rounded-lg p-6`}>
      <div className="flex items-center space-x-4">
        <Icon name={config?.icon} size={32} className={config?.color} />
        <div>
          <h2 className={`text-xl font-bold ${config?.color}`}>{config?.label}</h2>
          <p className="text-sm text-muted-foreground">{config?.desc}</p>
        </div>
      </div>
    </div>
  );
};

export default OverallHealthIndicator;